<template>
  <button v-if="deveExibir">
    <div class="linha" @click="mostrarVisoes()">
      <p>Alterar Visão</p>
      <img
        src="@/assets/imgs/icone_topo_branco.png"
        :style="listaVisoesAbertaComp ? 'transform: rotate(0deg)' : ''"
      />
    </div>
    <div>
    </div>
    <ul v-if="listaVisoesAbertaComp">
      <li @click="mudarVisao(1)">
        <p>
          <a :class="linkClass(1)" href="javascript:void(0)">Administrativo</a>
        </p>
      </li>
      <li @click="mudarVisao(3)" v-if="acessoCanais.acessoVisaoPAP">
        <p>
          <a :class="linkClass(3)" href="javascript:void(0)">PAP</a>
        </p>
      </li>
      <li @click="mudarVisao(5)" v-if="acessoCanais.acessoVisaoLojaPropria">
        <p>
          <a :class="linkClass(5)" href="javascript:void(0)">Loja Própria</a>
        </p>
      </li>
      <li @click="mudarVisao(6)" v-if="acessoCanais.acessoVisaoRevenda">
        <p>
          <a :class="linkClass(6)" href="javascript:void(0)">Revenda</a>
        </p>
      </li>
    </ul>
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AlterarVisao',
  data() {
    return {
      listaVisoesAberta: false,
      canais: {}
    };
  },

  computed: {
    ...mapGetters({
      canal: 'home/canal',
      acessoCanais: 'home/acessoCanais'
    }),
    listaVisoesAbertaComp() {
      return this.listaVisoesAberta;
    },
    deveExibir() {
      return localStorage['revista.canal'] === "1" && (this.acessoCanais.acessoVisaoPAP || this.acessoCanais.acessoVisaoLojaPropria || this.acessoCanais.acessoVisaoRevenda)
    }
  },

  methods: {
    ...mapActions({
      setCanalHome: 'home/setCanal',
      getAcessoVisoesCanais: 'home/getAcessoVisoesCanais'
    }),
    mostrarVisoes() {
      this.listaVisoesAberta = !this.listaVisoesAberta;
    },
    mudarVisao(canal) {
      // Persiste o canal simulado (usado por 'home/canal' e por 'env.revista.canal').
      this.setCanalHome(canal);
      // Recarrega o portal na home para que todas as seções (slider, barra de
      // acesso, destaques, categorias, permissões etc.) renderizem no canal escolhido.
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
      window.location.reload();
    },
    estadoDoPerfil() {
      this.perfilAtivo = !this.perfilAtivo;
      this.listaVisoesAberta = false;
    },
    linkClass(value){
      return this.canal == value ? 'ativo' : 'inativo';
    }
  },
  async mounted() {
    await this.getAcessoVisoesCanais();
  }
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

button {
  cursor: pointer;
  user-select: none;
  background: transparent;
  border: 0px;
  outline: none;
}

.perfil {
  position: relative;
  margin-left: 10px;

  & .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 34px;
    background: $cor_roxo;
    transition: all 0.2s ease-in-out;
    padding: 0px;

    & img {
      z-index: 2;
      width: 13px;
      height: 13px;
      margin-top: -2px;
    }

    & .seta {
      width: 10px;
      height: 10px;
      background: $cor_roxo;
      z-index: -1;
      position: absolute;
      border-radius: 2px;
      bottom: 0;
      left: 50%;
      margin-bottom: 10px;
      transition: all 0.2s ease-in-out;
      transform: translate(-50%, 0) rotate(45deg);
    }

    &:hover {
      background: $cor_amarelo;

      & > .seta {
        background: $cor_amarelo;
      }
    }
  }

  & .ativo {
    font-weight: bold;
  }

  & .menu {
    position: absolute;
    background: $cor_roxo;
    border-radius: 5px 5px 0 0;
    width: 200px;
    top: 45px;
    right: 0;
    padding-bottom: 10px;
    box-shadow: 0px 7px 15px rgba(black, 0.4);
    animation: abrir 0.2s 1 ease-in-out;

    & .header {
      font-size: 14px;
      font-family: 'OpenSans';
      border-radius: 5px 5px 0 0;
      padding: 20px 20px 5px;
      color: $cor_roxo;
      font-weight: bold;
      font-style: italic;
      background: $cor_amarelo;
    }

    & .opcoes {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 10px 0;

      & button {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        position: relative;
          font-family: 'VivoType';
        font-size: 14px;
        font-weight: bold;
        border-bottom: 1px solid rgba(white, 0.08);
        padding: 15px 0px;
        width: calc(100% - 40px);

        & .linha {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          // width: calc(100% - 40px);
          // padding: 0 20px;

          & p {
            letter-spacing: 0.05em;
            color: white;
            margin: 0px;
            transition: all 0.1s ease-in-out;
          }

          & strong {
            font-family: 'OpenSans';
            font-size: 13px;
            letter-spacing: 0;
            opacity: 0.5;
            font-weight: 200;
            // color: $cor_amarelo
          }

          & img {
            width: 6px;
            height: 6px;
            // transition: all .2s ease-in-out;
            transform: rotate(180deg);
          }
        }

        &:hover > .linha p {
          color: $cor_amarelo !important;
        }

        &:hover > .linha strong {
          opacity: 1;
        }

        &:hover > .linha img {
          filter: sepia(1) brightness(0.13) grayscale(0) saturate(1000)
            hue-rotate(308deg);
        }

        & ul {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: right;
          width: 100%;
          margin-left: -5px;
          padding: 10px 0 5px;

          & li {
            display: flex;
            width: 100%;
            height: 30px;
            margin-bottom: 0px;

            & a {
              font-family: 'OpenSans';
              letter-spacing: 200;
              line-height: 1em;
              color: rgba(white, 0.5);
              text-decoration: none;



            }
             &:hover {
                & a {
                  color: white;
                }
              }

            .inativo {
              font-weight: normal;
            }
            .ativo {
              font-weight: bold;
              color: white;
            }

            & span {
              font-weight: 100;
              color: rgba(white, 0.15);
            }
          }
        }
      }
    }

    & .sair {
      position: absolute;
      color: rgba(white, 0.5);
      font-family: 'OpenSans';
      font-weight: bold;
      padding: 0px;
      font-size: 11px;
      right: 20px;
      bottom: 15px;

      &:hover {
        color: white;
      }
    }
  }
}

@keyframes abrir {
  0% {
    opacity: 0;
    margin-top: -30px;
  }
  100% {
    opacity: 1;
    margin-top: 0px;
  }
}

@media all and (min-width: 300px) and (max-width: 1160px) {
}
</style>
